export const FETCH_COLOCATION_ACCESS_IS_COMPLETE = 'FETCH_COLOCATION_ACCESS_IS_COMPLETE';

export const FETCH_COLOCATION_ACCESS_IS_PENDING = 'FETCH_COLOCATION_ACCESS_IS_PENDING';

export const FETCH_COLOCATION_ACCESS_IS_ERROR = 'FETCH_COLOCATION_ACCESS_IS_ERROR';

export const FETCH_COLOCATION_REVOKED_ACCESS_IS_COMPLETE = 'FETCH_COLOCATION_REVOKED_ACCESS_IS_COMPLETE';

export const FETCH_COLOCATION_REVOKED_ACCESS_IS_PENDING = 'FETCH_COLOCATION_REVOKED_ACCESS_IS_PENDING';

export const FETCH_COLOCATION_REVOKED_ACCESS_IS_ERROR = 'FETCH_COLOCATION_REVOKED_ACCESS_IS_ERROR';

export const FETCH_COLOCATION_ACCESS_BY_ID_IS_COMPLETE = 'FETCH_COLOCATION_ACCESS_BY_ID_IS_COMPLETE';

export const FETCH_COLOCATION_ACCESS_BY_ID_IS_PENDING = 'FETCH_COLOCATION_ACCESS_BY_ID_IS_PENDING';

export const FETCH_COLOCATION_ACCESS_BY_ID_IS_ERROR = 'FETCH_COLOCATION_ACCESS_BY_ID_IS_ERROR';

export const ACCESS_REQUEST_IS_COMPLETE = 'ACCESS_REQUEST_IS_COMPLETE';

export const ACCESS_REQUEST_IS_PENDING = 'ACCESS_REQUEST_IS_PENDING';

export const ACCESS_REQUEST_IS_ERROR = 'ACCESS_REQUEST_IS_ERROR';

export const ACCESS_UPDATE_IS_COMPLETE = 'ACCESS_UPDATE_IS_COMPLETE';

export const ACCESS_UPDATE_IS_PENDING = 'ACCESS_UPDATE_IS_PENDING';

export const ACCESS_UPDATE_IS_ERROR = 'ACCESS_UPDATE_IS_ERROR';

export const DELETE_ACCESS = 'DELETE_ACCESS';

export const DELETE_ACCESS_IS_PENDING = 'DELETE_ACCESS_IS_PENDING';

export const DELETE_ACCESS_IS_ERROR = 'DELETE_ACCESS_IS_ERROR';

export const FETCH_DOCUMENT = 'FETCH_DOCUMENT';

export const FETCH_DOCUMENT_IS_PENDING = 'FETCH_DOCUMENT_IS_PENDING';

export const FETCH_DOCUMENT_IS_ERROR = 'FETCH_DOCUMENT_IS_ERROR';

export const ADD_DOCUMENT = 'ADD_DOCUMENT';

export const ADD_DOCUMENT_IS_PENDING = 'ADD_DOCUMENT_IS_PENDING';

export const ADD_DOCUMENT_IS_ERROR = 'ADD_DOCUMENT_IS_ERROR';

export const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT';

export const UPDATE_DOCUMENT_IS_PENDING = 'UPDATE_DOCUMENT_IS_PENDING';

export const UPDATE_DOCUMENT_IS_ERROR = 'UPDATE_DOCUMENT_IS_ERROR';

export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';

export const DELETE_DOCUMENT_IS_PENDING = 'DELETE_DOCUMENT_IS_PENDING';

export const DELETE_DOCUMENT_IS_ERROR = 'DELETE_DOCUMENT_IS_ERROR';

export const REVOKED_ACCESS = 'REVOKED_ACCESS';

export const REVOKED_ACCESS_IS_PENDING = 'REVOKED_ACCESS_IS_PENDING';

export const REVOKED_ACCESS_IS_ERROR = 'REVOKED_ACCESS_IS_ERROR';

export const SORT = 'SORT';

export const SORT_REVOKE = 'SORT_REVOKE';

export const FILTER_ACCESS = 'FILTER_ACCESS';

export const RESTORE_ACCESS = 'RESTORE_ACCESS';

export const RESTORE_ACCESS_IS_PENDING = 'RESTORE_ACCESS_IS_PENDING';

export const RESTORE_ACCESS_IS_ERROR = 'RESTORE_ACCESS_IS_ERROR';
